import { SpcSamplingMethod } from "src/components/views/spc/masterData/controlCharts/form/samplingMethod/SpcSamplingMethod.tsx";

export const getStaticValueSamplingMethod = (): SpcSamplingMethod => {
	return {
		key: "dev_method_3",
		label: "Dev method (Static values)",
		renderParameterFields: () => <></>,
	};
};
